<template>
    <div>
        <p style="font-size: larger;font-weight: bolder">大额红包审核</p>
        <div style="border-style: solid;border-bottom-width: 1px;margin-bottom: 20px"/>

        <el-form :inline="true">
            <el-form-item>
                <el-input placeholder="请输入用户账户" v-model="queryCondition.userId"/>
            </el-form-item>
            <el-form-item label="红包类型">
                <el-select v-model="queryCondition.type">
                    <el-option v-for="item in redTypes" :label="item.desc" :key="item.code" :value="item.code"/>
                </el-select>
            </el-form-item>
            <el-form-item label="红包状态">
                <el-select v-model="queryCondition.status">
                    <el-option v-for="item in redStatus" :label="item.desc" :key="item.code" :value="item.code"/>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="queryInfoList(1)">搜索</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="auditList">
            <el-table-column label="创建红包账户" prop="userId"/>
            <el-table-column label="红包类型">
                <template slot-scope="scope">
                    {{scope.row.type === 1 ? '普通红包' : scope.row.type === 2 ? '新手红包' : '未知'}}
                </template>
            </el-table-column>
            <el-table-column label="红包币种" prop="coinType"/>
            <el-table-column label="红包金额" prop="totalVolume"/>
            <el-table-column label="红包个数" prop="quantity"/>
            <el-table-column label="红包状态">
                <template slot-scope="scope">{{parseDesc(scope.row.status,redStatus)}}</template>
            </el-table-column>
            <el-table-column label="红包昵称" prop="nickName"/>
            <el-table-column label="祝福语" prop="greetings"/>
            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    {{scope.row.createTime | moment}}
                </template>
            </el-table-column>
            <el-table-column label="不通过理由" prop="auditDes"/>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" @click="auditInfo.id=scope.row.id,auditInfo.showEdit=true" v-if="scope.row.status === 1 || scope.row.status === 2">审核</el-button>
                    <el-button type="primary" @click="goRecord(scope.row.id)">领取明细</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination background layout="prev, pager, next" :total="total" :page-size="10" :current-page="queryCondition.pageNo" @current-change="queryInfoList"/>

        <el-dialog  title="提示" :visible.sync="auditInfo.showEdit" width="30%" @close="closeAudit()">
           <el-form>
               <el-form-item>
                   <el-select v-model="auditInfo.isPass">
                      <el-option v-for="item in passType" :label="item.desc" :key="item.code" :value="item.code"/>
                   </el-select>
               </el-form-item>
               <el-form-item v-show="auditInfo.isPass === false">
                   <p style="color: red">审核不通过，红包将直接系统取消，支付金额归还账户，请填写不通过理由：</p>
                   <el-input type="textarea" v-model="auditInfo.description"/>
               </el-form-item>
               <el-form-item v-show="auditInfo.isPass === true">
                   <p style="color: red">审核通过，用户即可分发红包</p>
               </el-form-item>
               <el-form-item>
                   <el-button type="info" @click="closeAudit()">取消</el-button>
                   <el-button type="primary" @click="auditRed()">确认</el-button>
               </el-form-item>
           </el-form>
        </el-dialog>

    </div>
</template>

<script>
    import api from './api';
    import router from '../../router';
    export default {
        name: "auditRed",
        data() {
            return {
                redTypes: [{code: '', desc: '全部'}, {code: 1, desc: '普通红包'}, {code: 2, desc: '新手红包'}],
                redStatus: [{code: '', desc: '全部'},{code:1,desc:'创建'},{code: 2, desc: '审核'}, {code: -2, desc: '审核不通过'},
                    {code: -4, desc: '用户取消'},{code: 3,desc: '领取和待完成转账'},{code: 4,desc: '领取并转账完，或者过期未完成转账回退'}],
                queryCondition: {type:'',status:'',pageNo:1},
                auditList: [],
                total:0,
                auditInfo: {
                    showEdit: false,
                    id: '',
                    isPass: false
                },
                passType: [{code: true,desc:'审核通过'},{code:false,desc:'审核不通过'}]
            }
        },
        created() {
          this.queryInfoList(1);
        },
        methods:{
            queryInfoList(val) {
                this.queryCondition.page = val;
               api.redEnvelopeList(this.queryCondition).then(response =>{
                   this.auditList = response.data.list;
                   this.total = response.data.totalCount;
               })
            },
            auditRed() {
               api.audit(this.auditInfo).then(() =>{
                   this.$message.success('操作成功');
                   this.closeAudit();
                   this.queryInfoList(1);
               })
            },
            closeAudit() {
                this.auditInfo.showEdit = false;
            },
            parseDesc(code,list) {
                for(let i in list) {
                    if (code === list[i].code) {
                        return list[i].desc;
                    }
                }
            },
            goRecord(id) {
                router.push({
                    name: 'redDetail',
                    params: {
                        redEnvelopeId : id
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
